import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { SEOHeader } from 'views/components';
import PrinterAccess from './printer-access';
import { _Object } from 'utils/interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { printReceipt } from 'utils';
import { orderService } from 'services';
import { addToCart, setCustomer } from 'redux/slices/cart.slice';

import { toast } from 'react-toastify';
import SalesTemplate1 from './template1';
import MobileTemplate from './mobile-template';
// import SalesTemplate2 from './template2';
// import SalesTemplate3 from './template3';
// import SalesTemplate4 from './template4';

const Sales = () => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const { cart } = useSelector((state: _Object) => state.cart);
  const { me, printerDevice } = useSelector((state: _Object) => state.session);

  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.innerWidth < 768,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const orderFormik = useFormik({
    initialValues: {
      amount: 0,
      discount: 0,
      order_note: '',
      payment_mode: 'cash',
      payment_ref_number: '',
      payment_terms: '',
      card_type: 'Debit Card',
      remark: '',
      cash_received: 0,
      split_payments: [] as any[],
      transaction_data: null as any,
    },
    enableReinitialize: true,
    onSubmit: () => {
      placeOrder();
    },
  });

  const placeOrder = async () => {
    setBtnLoading(true);
    const customerPayload: _Object = {};
    if (cart.customer?.id) {
      customerPayload.id = cart.customer.id;
    } else if (cart.customer?.mobile_number) {
      customerPayload.mobile_number = cart.customer.mobile_number;
      customerPayload.first_name =
        cart.customer.first_name || cart.customer.name || 'Walk-in';
      customerPayload.last_name = cart.customer.last_name || '';
    }

    const currentRemark = orderFormik.values.remark || null;

    const payLoad = {
      customer: customerPayload,
      status: 'completed',
      order_items: (cart.lineItems || []).map((item: _Object) => {
        return {
          quantity: Number(item.quantity) || 1,
          discount: item.discount || 0,
          product_id: item.id || item._id,
        };
      }),
      discount:
        Number(orderFormik.values.discount || cart?.discount || 0) || null,
      location_id: me?.location?.id || me?.location_id || null,
      order_note: orderFormik.values.order_note || null,
      remark: currentRemark,
      fee: 0,
      billing: {
        address1: cart.customer.address1 || null,
        address2: cart.customer.address2 || null,
        city: cart.customer.city || null,
        state: cart.customer.state || null,
        country: cart.customer.country || null,
        postcode: cart.customer.postcode || null,
      },
      payment: {
        amount: orderFormik.values.amount || 0,
        payment_mode: orderFormik.values.payment_mode || 'cash',
        payment_terms: orderFormik.values.payment_terms || null,
        payment_ref_number: orderFormik.values.payment_ref_number || null,
        remark: currentRemark,
        transaction_data: orderFormik.values.transaction_data || {
          card_type: orderFormik.values.card_type || null,
          remark: currentRemark,
          cash_received: orderFormik.values.cash_received || null,
          split_payments: orderFormik.values.split_payments?.length
            ? orderFormik.values.split_payments
            : null,
        },
      },
    };
    const data: _Object = await orderService.createOrder(payLoad);
    setBtnLoading(false);
    if (data?.error === false) {
      printReceipt(printerDevice, data.data, me);
      try {
        localStorage.setItem('pos_last_completed_order', JSON.stringify(data.data));
      } catch (e) {
        console.error(e);
      }

      // doReceiptPrint(printerDevice, cart, data.data.created_at, globalSettings, data.data.order_number, orderFormik.values.payment_mode)
      dispatch(setCustomer({}));
      dispatch(addToCart([]));
      orderFormik.resetForm();
    } else if (data?.message) {
      toast.error(data.message);
    }
  };

  // const selectTemplate = () => {
  // 	switch (me?.client?.pos_system_type) {
  // 		case 1:
  // 			return <SalesTemplate1 orderFormik={orderFormik} btnLoading={btnLoading} />;

  // 		case 2:
  // 			return <SalesTemplate2 orderFormik={orderFormik} btnLoading={btnLoading} />;

  // 		case 3:
  // 			return <SalesTemplate3 orderFormik={orderFormik} btnLoading={btnLoading} />;

  // 		case 4:
  // 			return <SalesTemplate4 orderFormik={orderFormik} btnLoading={btnLoading} />;
  // 	}
  // };

  return (
    <>
      <SEOHeader title="Checkout" />
      {isMobile ? (
        <MobileTemplate orderFormik={orderFormik} btnLoading={btnLoading} />
      ) : (
        <div className="h-100">
          <SalesTemplate1 orderFormik={orderFormik} btnLoading={btnLoading} />
        </div>
      )}
      <PrinterAccess />
    </>
  );
};
export default Sales;
